import React from 'react';
import { X, Play, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

export const DemoLoginModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleDemoOpen = () => {
    navigate('/demo');
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      onClick={onClose}
    >
      <div 
        className="relative max-w-md w-full rounded-3xl p-8"
        style={{ 
          backgroundColor: '#0F141A',
          border: '2px solid #1F2937'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-lg hover:bg-white/10 transition-colors"
        >
          <X className="w-5 h-5" style={{ color: '#94A3B8' }} />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div 
            className="w-16 h-16 rounded-2xl flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #7CD4FD 0%, #1EA0E6 100%)' }}
          >
            <Play className="w-8 h-8 text-white" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-center mb-3" style={{ color: '#E6EDF3' }}>
          Kostenlos testen
        </h2>
        <p className="text-center mb-6" style={{ color: '#94A3B8' }}>
          Entdecken Sie alle Funktionen mit unserem Demo-Account – keine Registrierung erforderlich!
        </p>

        {/* Demo Features */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3 p-3 rounded-lg" style={{ backgroundColor: '#1F2937' }}>
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#22C55E' }}></div>
            <span style={{ color: '#E6EDF3' }}>3 kostenlose Diagnosen</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg" style={{ backgroundColor: '#1F2937' }}>
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#22C55E' }}></div>
            <span style={{ color: '#E6EDF3' }}>Alle Features verfügbar</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg" style={{ backgroundColor: '#1F2937' }}>
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#22C55E' }}></div>
            <span style={{ color: '#E6EDF3' }}>Beispiel-Fahrzeug inklusive</span>
          </div>
        </div>

        {/* Demo Button */}
        <Button
          onClick={handleDemoOpen}
          className="w-full py-6 rounded-xl font-bold text-lg transition-all duration-300"
          style={{
            background: 'linear-gradient(135deg, #7CD4FD 0%, #1EA0E6 100%)',
            color: '#fff'
          }}
        >
          Demo anschauen
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>

        {/* Info Text */}
        <p className="text-xs text-center mt-4" style={{ color: '#6B7280' }}>
          Keine Anmeldung erforderlich • Nur zur Ansicht
        </p>

        {/* Divider */}
        <div className="flex items-center gap-4 my-6">
          <div className="flex-1 h-px" style={{ backgroundColor: '#1F2937' }}></div>
          <span style={{ color: '#6B7280', fontSize: '12px' }}>ODER</span>
          <div className="flex-1 h-px" style={{ backgroundColor: '#1F2937' }}></div>
        </div>

        {/* Signup Link */}
        <button
          onClick={() => {
            onClose();
            navigate('/signup');
          }}
          className="w-full py-4 rounded-xl font-semibold transition-colors"
          style={{ 
            backgroundColor: '#1F2937',
            color: '#7CD4FD',
            border: '1px solid #374151'
          }}
        >
          Eigenen Account erstellen
        </button>
      </div>
    </div>
  );
};
